<div class="driver-profile__pagination">
	<ul class="d-flex gap-2 mb-0 p-0">
		<li [ngClass]="{ disabled: currentPage == 1 }" (click)="changePage(1)"
			class="pagination-list_page pagination-list_prev pointer-event">
			<span>
				<svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M8.24767 4.49573L7.42283 3.6709L4.09375 6.99998L7.42283 10.3291L8.24767 9.50423L5.74342 6.99998L8.24767 4.49573Z"
						fill="#9FA1A4" />
					<path
						d="M10.3395 3.6709L7.01042 6.99998L10.3395 10.3291L11.1643 9.50423L8.66008 6.99998L11.1643 4.49573L10.3395 3.6709Z"
						fill="#9FA1A4" />
				</svg>
			</span>
		</li>
		<li [ngClass]="{ disabled: currentPage == 1 }" (click)="previousPage()"
			class="pagination-list_page pagination-list_prev pointer-event">
			<span [ngClass]="{ disabled: currentPage == 1, 'hover:bg-primary': currentPage > 1 }">
				<svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M8.5869 3.6709L5.25781 6.99998L8.5869 10.3291L9.41173 9.50423L6.90748 6.99998L9.41173 4.49573L8.5869 3.6709Z"
						fill="#9FA1A4" />
				</svg>
			</span>
		</li>

		<li *ngFor="let page of getPages(); let i = index" [ngClass]="{
      'pagination-list_page': true,
      'pointer-event': page !== '...',
      'active': page === currentPage,
			'is-input': page === '...' && activeEllipsisIndex === i
    }" (click)="page !== '...' ? changePage(page) : activeEllipsisIndex = i">
			<ng-container *ngIf="page === '...' && activeEllipsisIndex === i; else pageContent">
				<input type="number" min="1" [(ngModel)]="customPage"
					(keydown.enter)="goToPage($event); activeEllipsisIndex = null" (blur)="activeEllipsisIndex = null"
					class="pagination-input no-spinner" placeholder="Page" autofocus />
			</ng-container>

			<ng-template #pageContent>
				<span *ngIf="page === '...'; else numberPage" (click)="activeEllipsisIndex = i">...</span>
				<ng-template #numberPage>
					<span>{{ page }}</span>
				</ng-template>
			</ng-template>
		</li>

		<li [ngClass]="{ disabled: (currentPage == totalPages || totalPages == 0) }" (click)="nextPage()"
			class="pagination-list_page pagination-list_next pointer-event">
			<span [ngClass]="{ disabled: currentPage == totalPages, 'hover:bg-primary': currentPage < totalPages}">
				<svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M6.41077 10.3291L9.73985 6.99998L6.41077 3.6709L5.58594 4.49573L8.09019 6.99998L5.58594 9.50423L6.41077 10.3291Z"
						fill="#9FA1A4" />
				</svg>
			</span>
		</li>
		<li [ngClass]="{ disabled: (currentPage == totalPages || totalPages == 0) }" (click)="changePage(this.totalPages)"
			class="pagination-list_page pagination-list_next pointer-event">
			<span>
				<svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M6.16667 4.49728L8.68958 6.99978L6.16667 9.50228L6.988 10.3306L10.3463 6.99978L6.988 3.66895L6.16667 4.49728Z"
						fill="#9FA1A4" />
					<path
						d="M4.07133 3.66895L3.25 4.49728L5.77292 6.99978L3.25 9.50228L4.07133 10.3306L7.42958 6.99978L4.07133 3.66895Z"
						fill="#9FA1A4" />
				</svg>
			</span>
		</li>
	</ul>
</div>